<div class="progressTracker" *ngIf="questionnaireList == undefined || questionnaireList == null || questionnaireList.length <= 0"
[ngClass]="isArabic ? 'rightAlign' : ''">
  <p>
      <span *ngIf="!isArabic">Nothing to see here!! You will see the status once an assessment been initiated.</span>
      <span *ngIf="isArabic">لا يوجد تقييم على الشركة حالياً !! ستتمكنون من متابعة التقييم فور إطلاقه.</span>
    </p>
</div>
<div class="col-12 progressTracker" *ngIf="questionnaireList && questionnaireList.length > 0">
  <label *ngIf="isMakerCheckerEnabled && !isChecker" class="tip mb-2" [ngClass]="isArabic ? 'rightAlign' : ''">
    <span *ngIf="!isArabic">Tip: If the progress is 100% and Status is Maker submitted, Please ask the executor checker to approve the assessment.</span>
    <span *ngIf="isArabic">نصيحة: إذا كان التقدم بنسبة 100٪ وتم إرسال Status إلى Maker ، فيرجى مطالبة مدقق المنفذ بالموافقة على التقييم</span>
  </label>
  <table class="table table-striped table-bordered customTable" *ngIf="!isArabic">
    <thead>
      <tr>
        <th>
          <span *ngIf="!isArabic">Assessment</span>
          <!-- <span *ngIf="isArabic">التقييم</span> -->
        </th>
       
        <th class="midAlign">
          <span *ngIf="!isArabic">Total Completion</span>
          <!-- <span *ngIf="isArabic">نسبة الإنجاز الإجمالية </span> -->
        </th>
        <th class="midAlign">
          <span *ngIf="!isArabic">Status</span>
          <!-- <span *ngIf="isArabic">الحالة</span> -->
        </th>
        <th class="midAlign">
          <span>#</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of questionnaireList">
        <td>{{ item.questionnaireName }}</td>
        <td class="midAlign">{{ item.questionnaireProgress}}%</td>
        <td class="midAlign">{{ item.questionnaireStatus}}</td>
        <td class="midAlign showTxt" (click)="showProgressDetails(item)">
          
        <span *ngIf="!isArabic">Show Details</span>
        <span *ngIf="isArabic">عرض التفاصيل</span>

        </td>
      </tr>
    </tbody>
  </table>
  <table class="table table-striped table-bordered customTable" *ngIf="isArabic">
    <thead>
      <tr>
        <th class="midAlign">
          <span>الرقم</span>
        </th>
        <th class="midAlign">
          <span *ngIf="isArabic">الحالة</span>
        </th>
        <th class="midAlign">
          <span *ngIf="isArabic">نسبة الاكتمال</span>
        </th>
        <th class="rightAlign">
          <span *ngIf="isArabic">تقييم</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of questionnaireList">
        <td class="midAlign showTxt" (click)="showProgressDetails(item)">اظهر التفاصيل</td>
        <td class="midAlign">{{ item.questionnaireStatus}}</td>
        <td class="midAlign">{{ item.questionnaireProgress}}%</td>
        <td class="rightAlign">{{ item.questionnaireName }}</td>
      </tr>
    </tbody>
  </table>
</div>
<!-- <router-outlet></router-outlet> -->
<!-- <app-progress-detail-chart></app-progress-detail-chart> -->
